import Header from '../../../components/Header'
import UserMenu from '../../../components/UserMenu'
import Footer from '../../../components/Footer'
import BrainChat from '../../../components/BrainChat'
import { Navigate } from 'react-router-dom'
import { isGestorSemVenda } from '../../../services/gestor'

export default function Home() {
  if (isGestorSemVenda()) {
    return <Navigate to="/gestor" replace />
  }

  return (
    <>
        <BrainChat/>
        <Header/>
        <UserMenu/>
        <Footer/>
    </>
  )
}